import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateLinkPost = {
    path: "/affiliate/link",
    method: ERouteHttpVerb.POST
};
export { routeLocationAffiliateLinkPost };
